// Default portal props for all react-select components
export const defaultSelectPortalProps = {
  menuPortalTarget: document.body,
  menuPosition: "fixed",
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: false,
  closeMenuOnScroll: false,
};

const DropDownStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      backgroundColor: '#fff',
      border: '1px solid #e9ecef',
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      marginTop: 0,
      position: 'absolute',
    }),

    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),

    control: (provided, state) => ({
      ...provided,
      minHeight: '36px',
      backgroundColor: '#fff',
      border: '1px solid #e9ecef',
      borderRadius: '6px',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
      transition: 'all 0.3s ease',
      '&:hover': {
        border: '1px solid #232B2B',
        boxShadow: '0 2px 4px rgba(35, 43, 43, 0.15)',
      },
      ...(state.isFocused && {
        border: '1px solid #232B2B',
        boxShadow: '0 0 0 0.2rem rgba(35, 43, 43, 0.25)',
      }),
    }),

    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#f8f9fa' : '#fff',
      color: '#495057',
      cursor: 'pointer',
      padding: '8px 12px',
      fontSize: '13px',
      fontWeight: '500',
      transition: 'all 0.2s ease',
      '&:hover': {
        backgroundColor: '#f8f9fa',
      },
    }),

    singleValue: (provided) => ({
      ...provided,
      color: '#495057',
    }),

    placeholder: (provided) => ({
      ...provided,
      color: '#6c757d',
    }),

    input: (provided) => ({
      ...provided,
      color: '#495057',
    }),

    indicatorSeparator: (provided) => ({
      ...provided,
      backgroundColor: '#e9ecef',
    }),

    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#6c757d',
      '&:hover': {
        color: '#007bff',
      },
    }),
  };

// Dark mode styles for react-select
const DropDownStylesDark = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      backgroundColor: '#2d3436 !important',
      border: '1px solid #404040 !important',
      boxShadow: '0 4px 12px rgba(0,0,0,0.4) !important',
      marginTop: 0,
      borderRadius: '6px !important',
      position: 'absolute',
    }),

    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),

    control: (provided, state) => ({
      ...provided,
      minHeight: '36px',
      backgroundColor: '#2d3436 !important',
      border: '1px solid #404040 !important',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2) !important',
      color: '#ffffff !important',
      borderRadius: '6px !important',
      transition: 'all 0.3s ease',
      '&:hover': {
        border: '1px solid #606060 !important',
        boxShadow: '0 2px 4px rgba(255, 255, 255, 0.1) !important',
        backgroundColor: '#2d3436 !important',
      },
      ...(state.isFocused && {
        border: '1px solid #ffffff !important',
        boxShadow: '0 0 0 0.2rem rgba(255, 255, 255, 0.25) !important',
        backgroundColor: '#2d3436 !important',
      }),
    }),

    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#404040 !important' : '#2d3436 !important',
      color: '#ffffff !important',
      cursor: 'pointer',
      padding: '8px 12px',
      fontSize: '13px',
      fontWeight: '500',
      transition: 'all 0.2s ease',
      '&:hover': {
        backgroundColor: '#404040 !important',
      },
      ...(state.isSelected && {
        backgroundColor: '#606060 !important',
        color: '#ffffff !important',
      }),
    }),

    singleValue: (provided) => ({
      ...provided,
      color: '#ffffff !important',
    }),

    placeholder: (provided) => ({
      ...provided,
      color: '#adb5bd !important',
    }),

    input: (provided) => ({
      ...provided,
      color: '#ffffff !important',
    }),

    indicatorSeparator: (provided) => ({
      ...provided,
      backgroundColor: '#404040 !important',
    }),

    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: '#adb5bd !important',
      '&:hover': {
        color: '#ffffff !important',
      },
    }),

    clearIndicator: (provided) => ({
      ...provided,
      color: '#adb5bd !important',
      '&:hover': {
        color: '#ffffff !important',
      },
    }),

    menuList: (provided) => ({
      ...provided,
      backgroundColor: '#2d3436 !important',
      padding: '4px 0 !important',
    }),

    noOptionsMessage: (provided) => ({
      ...provided,
      color: '#adb5bd !important',
      backgroundColor: '#2d3436 !important',
    }),

    loadingMessage: (provided) => ({
      ...provided,
      color: '#adb5bd !important',
      backgroundColor: '#2d3436 !important',
    }),

    valueContainer: (provided) => ({
      ...provided,
      color: '#ffffff !important',
    }),
  };
  
export default DropDownStyles;
export { DropDownStylesDark };